export const login_ko = {
  'title-section': {
    title: '로그인',
    description: '삼성 비즈니스 계정으로 로그인하세요',
  },
  form: {
    fields: {
      'login-id': {
        label: '로그인 ID (이메일)',
        placeholder: '이메일을 입력하세요',
      },
      password: {
        label: '비밀번호',
        placeholder: '비밀번호를 입력하세요',
      },
      'forgot-password-link.title': '비밀번호를 잊으셨나요?',
      button: {
        'sign-in': '로그인',
        'samsung-employee-sign-in': '삼성 임직원 로그인',
      },
    },
  },
  success: {
    'mfa-success-title': 'MFA 로그인 성공',
    'mfa-success-description': '잠시후 서비스 페이지로 이동됩니다.',
  },
  errors: {
    'mfa-error-title': 'MFA 로그인 오류',
    'mfa-error-description': 'MFA 로그인에 실패했습니다. 다시 시도하세요.',
    'pending-registration': '등록 대기 중입니다.',
    'change-password': '비밀번호를 변경한 지 90일이 지났습니다.\n비밀번호를 변경해주세요.',
    'required-captcha': '캡챠를 진행하세요',
    'wrong-captcha': '잘못된 캡챠입니다.',
    'account-locked': '계정이 잠겨 있습니다.\n관리자에게 문의해주세요.',
    'invalid-parameter-value': '등록되지 않은 계정이거나 아이디 또는 비밀번호 정보가 일치하지 않습니다.',
    'email-or-password-incorrect': '이메일 주소 또는 비밀번호가 잘못되었습니다.\n다시 시도하세요.',
    'mfa-login-failed': 'MFA 로그인에 실패했습니다.',
    'tenure-check-failed': '재직 인증에 실패했습니다.',
    default: '잘못된 로그인 요청입니다.\n처음부터 다시 로그인하세요.',
  },
};
